<template>
    <transition name="page" mode="out-in">
        <div class="cover" v-if="loading">
            <div class="pacman">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </transition>
</template>

<style lang="stylus" scoped>
    .cover
        position fixed
        height 100%
        width 100%
        top 0
        left 0
        background #000
        z-index 1999

    @keyframes rotate_pacman_half_up
        0%
            transform rotate(270deg)
        50%
            transform rotate(360deg)
        100%
            transform rotate(270deg)

    @keyframes rotate_pacman_half_down
        0%
            transform rotate(90deg)
        50%
            transform rotate(0deg)
        100%
            transform rotate(90deg)

    @keyframes pacman-balls
        75%
            opacity 0.7
        100%
            transform translate(-100px, -6.25px)

    .pacman
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        z-index 1024

        & > div:nth-child(2)
            animation pacman-balls 1s -0.99s infinite linear

        & > div:nth-child(3)
            animation pacman-balls 1s -0.66s infinite linear

        & > div:nth-child(4)
            animation pacman-balls 1s -0.33s infinite linear

        & > div:nth-child(5)
            animation pacman-balls 1s 0s infinite linear

        & > div:first-of-type
            width: 0px;
            height: 0px;
            border-right: 25px solid transparent;
            border-top: 25px solid #7aabde;
            border-left: 25px solid #7aabde;
            border-bottom: 25px solid #7aabde;
            border-radius: 25px;
            animation: rotate_pacman_half_up 0.5s 0s infinite;
            position: relative;
            left: -30px

        & > div:nth-child(2)
            width: 0px;
            height: 0px;
            border-right: 25px solid transparent;
            border-top: 25px solid #7aabde;
            border-left: 25px solid #7aabde;
            border-bottom: 25px solid #7aabde;
            border-radius: 25px;
            animation: rotate_pacman_half_down 0.5s 0s infinite;
            margin-top: -50px;
            position: relative;
            left: -30px;

        & > div:nth-child(3),
        & > div:nth-child(4),
        & > div:nth-child(5),
        & > div:nth-child(6)
            background-color #7aabde
            width 15px
            height 15px
            border-radius 100%
            margin 2px
            width 10px
            height 10px
            position absolute
            transform translate(0, -6.25px)
            top 25px
            left 70px
</style>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'spinner',

        computed: {
            ...mapGetters({settings: 'local/settings'}),

            loading() {
                return this.settings('loading')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/spinner/Spinner.vue